import React, { useState } from "react";
import { Container, Carousel, Row, Col } from "react-bootstrap";

const data = [
  {
    id: 1,
    title: "Aligned with Your Working Model",
    description:
      "The team adapts to your workflows, tools, and communication style, so collaboration feels natural from the start.",
  },
  {
    id: 2,
    title: "Clear Roles and Ownership",
    description:
      "Each team member works with defined responsibilities, ensuring accountability and smoother day-to-day execution.",
  },
  {
    id: 3,
    title: "Integrated into Your Delivery Flow",
    description:
      "The offshore team becomes part of your ongoing work, not a separate layer that needs constant back-and-forth.",
  },
  {
    id: 4,
    title: "Consistent Communication and Visibility",
    description:
      "Regular updates, shared tracking, and clear reporting keep everyone aligned without adding unnecessary overhead.",
  },
  {
    id: 5,
    title: "Built for Continuity, Not Just Capacity",
    description:
      "The focus is on creating a team that stays effective over time, supporting ongoing delivery rather than short-term output.",
  },
];

// Function to group items per slide
const chunkArray = (arr, size) => {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
};

export default function OssShoreTeamCarousel() {
  const [index, setIndex] = useState(0);

  const itemsPerSlide = 3;
  const slides = chunkArray(data, itemsPerSlide);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <section className="padding-section-large approach-section bg-dark text-white">
      <Container>
        {/* Header */}

        <Row className='mb-4 pt-5 align-items-end mb-5'>
          <Col md={10}>
            <h2 className="heading-style-h2 pb-3">How We Set Up and Work with <span className="text-gradient-1">Offshore Teams</span></h2>
            <h5 className='heading-style-h5'>Focused on integration, communication, and long-term delivery alignment rather than just team setup..</h5>
          </Col>
          <Col md={2}>
            <div className="carousel-controls pb-3">
              <button className="nav-btn" onClick={() =>
                setIndex((index - 1 + slides.length) % slides.length)
              }>
                ‹
              </button>
              <button className="nav-btn" onClick={() => setIndex((index + 1) % slides.length)}>
                ›
              </button>
            </div>
          </Col>
        </Row>
        {/* Carousel */}
        <Carousel
          activeIndex={index}
          onSelect={handleSelect}
          controls={false}
          indicators={false}
          interval={null}
        >
          {slides.map((slide, slideIndex) => (
            <Carousel.Item key={slideIndex}>
              <Row>
                {slide.map((item) => (
                  <Col md={4} key={item.id} className="mb-4">
                    <div className="approach-card d-flex justify-content-between flex-column">
                      <div>
                        <h4 className="heading-style-h4 text-gradient-1">{item.id}</h4>
                        <h4 className="heading-style-h4 pb-5">{item.title}</h4>
                      </div>
                      <p>{item.description}</p>
                    </div>
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
        <Row>
          <div className='bg-gradient-2 text-white p-4 mx-auto text-center w-auto mt-5'>
            <p className='mb-0'>The focus is on making sure software works reliably in real use, not just in test cases.</p>
          </div>
        </Row>
      </Container>
    </section >
  );
}